"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processTargets = void 0;
const lodash_shuffle_1 = __importDefault(require("lodash.shuffle"));
const __1 = require("../");
const filter = (cards) => {
    return cards.filter((c) => { var _a; return !(c.uid && ((_a = c.modifiers) === null || _a === void 0 ? void 0 : _a.Camo)); });
};
const processTargets = ({ card, cardTargets, player, opponent, playerTarget, filterDamageModifiers, }) => {
    var _a, _b;
    if (cardTargets.select === __1.TargetSelect.ByPlayer && playerTarget) {
        let selectedTarget;
        let selectedTargetType;
        const findCard = (c) => c.uid === playerTarget;
        if (playerTarget === __1.TargetTypes.EnemyMonkey) {
            selectedTarget = __1.TargetTypes.EnemyMonkey;
            selectedTargetType = __1.TargetTypes.EnemyMonkey;
        }
        else if (playerTarget === card.uid) {
            selectedTarget = card;
            selectedTargetType = __1.TargetTypes.Self;
        }
        else if (player.board.find(findCard)) {
            selectedTarget = player.board.find(findCard);
            selectedTargetType = __1.TargetTypes.FriendlyCreature;
        }
        else if (opponent.board.find(findCard)) {
            selectedTarget = opponent.board.find(findCard);
            selectedTargetType = __1.TargetTypes.EnemyCreature;
        }
        else
            throw new Error('Cannot find target!');
        if (cardTargets.type.includes(selectedTargetType)) {
            if (filterDamageModifiers && selectedTarget !== __1.TargetTypes.EnemyMonkey) {
                // disallow choosing card with camo if filter is enabled
                if ((_a = selectedTarget.modifiers) === null || _a === void 0 ? void 0 : _a.Camo)
                    throw new __1.InvalidTargetError('Cannot attack card with Camo!');
                // or if the opponent has a blocker
                if (!((_b = selectedTarget.modifiers) === null || _b === void 0 ? void 0 : _b.Blocker) &&
                    opponent.board.find((c) => { var _a; return (_a = c.modifiers) === null || _a === void 0 ? void 0 : _a.Blocker; }))
                    throw new __1.InvalidTargetError('There is a blocker on the board!');
            }
            return [selectedTarget];
        }
        else
            throw new __1.InvalidTargetError('Invalid target!');
    }
    else if (cardTargets.select === __1.TargetSelect.ByPlayer && !playerTarget) {
        throw new __1.MissingTargetError();
    }
    else if (cardTargets.select === __1.TargetSelect.Auto) {
        const selectableTargets = (0, __1.getValidTargets)(card, cardTargets, player, opponent);
        let selectedTargets = [];
        if (cardTargets.count === 'ALL') {
            selectedTargets = selectableTargets;
        }
        else if (typeof cardTargets.count === 'number') {
            selectedTargets = (0, lodash_shuffle_1.default)(selectableTargets).slice(0, cardTargets.count);
        }
        else
            selectedTargets = selectableTargets;
        // blockers are not checked here because spells can bypasss
        if (filterDamageModifiers)
            selectedTargets = filter(selectedTargets);
        return selectedTargets;
    }
    else
        throw new Error('Target select not recognised!');
};
exports.processTargets = processTargets;
